import { Dialog, TextField } from "@mui/material";
import React from "react";
import { FormWizardTemplate, Stages } from "@iventis/components";
import { translate } from "@iventis/translations/translation";
import { Content } from "@iventis/translations";
import { styled, StyledFieldLabel } from "@iventis/styles";

interface VenueBookmarkFormProps {
    onBookmarkCreate: (bookmarkName: string) => void;
    onCancel: () => void;
}

export const VenueBookmarkForm: React.FC<VenueBookmarkFormProps> = ({ onBookmarkCreate, onCancel }) => {
    const [nameValue, setValue] = React.useState("");
    const [submitting, setSubmitting] = React.useState(false);

    const Stages: Stages = [
        {
            primaryButtonText: translate(Content.common.buttons.save),
            primaryButtonCallback: () => {
                setSubmitting(true);
                onBookmarkCreate(nameValue);
            },
            secondaryButtons: [{ buttonText: translate(Content.common.buttons.cancel), onButtonPressed: onCancel }],
            isValid: nameValue.length > 0,
        },
    ];

    return (
        <Dialog open maxWidth="lg">
            <FormWizardTemplate title={translate(Content.map10.venue_bookmark_form.save)} stages={Stages} currentStage={0} isSubmitting={submitting}>
                <StyledFieldLabel>{translate(Content.map10.venue_bookmark_form.name)}</StyledFieldLabel>
                <StyledTextField value={nameValue} onChange={(event) => setValue(event.target.value)} data-testid="map-saved-view-name-input" />
            </FormWizardTemplate>
        </Dialog>
    );
};

const StyledTextField = styled(TextField)`
    width: 100%;
`;
